import { APIService } from '../api';
import { ApparelCategory } from './ApparelCategory';
import { Model } from './Model';
import { HasOne, Relations, Relationship } from './Relations';

export class Customer extends Model implements Relations<Customer> {
    public readonly blueprint = Customer;
    public readonly endpoint = APIService.createEndpoint('apparel-customers');
    user_id: number;
    salesman_id: number;
    organization_name: string;
    credit: string;
    location_id: number;
    location: any;
    shipping_locations: any[];
    category: ApparelCategory;

    public relations(): Relationship<{ new (): Customer }>[] {
        return [HasOne('category', ApparelCategory, Customer)];
    }
}
